import './Spinner.css'
import { Icon } from './Icon'

export function Spinner() {
  return (
    <div className='Spinner'>
      <Icon icon='spinner' />
    </div>
  )
}
